module.exports = __webpack_public_path__ + "img/ymyc6.e15ce0bd.jpg";